import { isEqual } from 'lodash'

type AlwaysPresentApiKeys = {
	id?: string
	_version?: number | null
	_deleted?: boolean | null
	_lastChangedAt?: number | null
	createdOn?: string | null
	updatedOn?: string | null
	updatedAt?: string | null
}

function getProperUpdateValues<T extends AlwaysPresentApiKeys>({
	updatedInput,
	originalInput,
}: {
	updatedInput: Partial<T>
	originalInput: T
}) {
	const updateInput = {} as Partial<T>
	for (const property in updatedInput) {
		const typedProperty = property as keyof typeof updatedInput
		// Only updates the property that is different
		if (
			!isEqual(updatedInput[typedProperty], originalInput[typedProperty])
		) {
			if (
				(originalInput[typedProperty] === null ||
					originalInput[typedProperty] === undefined ||
					originalInput[typedProperty] === '' ||
					originalInput[typedProperty] === 0) &&
				(updatedInput[typedProperty] === null ||
					updatedInput[typedProperty] === undefined ||
					updatedInput[typedProperty] === '' ||
					updatedInput[typedProperty] === 0) &&
				typedProperty !== 'total'
			) {
				continue
			}
			updateInput[typedProperty] = updatedInput[typedProperty] as any
		}
	}
	updateInput._deleted = undefined
	updateInput._lastChangedAt = undefined
	updateInput.createdOn = undefined
	updateInput.updatedOn = undefined
	updateInput.updatedAt = undefined

	updateInput.id = originalInput.id
	const cleanedObj = removeUndefinedKeys(updateInput)
	return cleanedObj
}

function hasBusinessChanges(input: Record<string, any>) {
	const ignoredKeys = new Set([
		'id',
		'__typename',
		'_version',
		'_deleted',
		'_lastChangedAt',
		'createdAt',
		'updatedAt',
		'createdOn',
		'updatedOn',
	])

	return Object.keys(input).some((key) => !ignoredKeys.has(key))
}

function removeUndefinedKeys(obj: Record<string, any>) {
	return Object.fromEntries(
		Object.entries(obj).filter(([_, value]) => value !== undefined)
	)
}

export { getProperUpdateValues, hasBusinessChanges }
